/* eslint-disable no-unused-vars */
import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import React, { Fragment, useState, useEffect } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

import { Form, Select, Popconfirm, Collapse, Tooltip,Button } from 'antd';
import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import { QuestionCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import {
  getToolsList,
  getMaterialsList,
  checkAvailability,
} from '../../../Utils/FormCalls';

const { Option } = Select;
const { Panel } = Collapse;

const ToolsformFunction = (props) => {
  const [toolsList, setTool] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache);
  useEffect(() => {
    (async () => {
      try {
        let response = await getToolsList();
        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);
  return (
    <Form.List name={'Tools'}>
      {(Tools, { add, remove }) => {
        return (
          <Fragment>
            <Form.Item>
              {' '}
              <div style={{ display: 'flex', justifyContent: 'right' }}>
                <Button
                  type="dashed"
                  style={{ background: '#29415a', color: '#fff' }}
                  onClick={() => {
                    add();
                  }}
                >
                  {' '}
                  {translation(translationCache, constant.addTools)}{' '}
                </Button>
              </div>
            </Form.Item>
            {Tools && Array.isArray(Tools) && Tools.length > 0 ? (
              <Collapse accordion defaultActiveKey={[]}>
                {Tools.map((tool, index2) => (
                  <Panel
                    key={index2}
                    header={`${translation(translationCache, constant.tools)}${index2 + 1}`}
                    extra={
                      <Popconfirm
                        title={translation(translationCache, constant.deleteTool2)}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        // onConfirm={() => remove(tool.name)}
                        onConfirm={() => remove(tool.name)}
                        okText={translation(translationCache, constant.yes)}
                        cancelText={translation(translationCache, constant.no)}
                      >
                        <Tooltip title={translation(translationCache, 'Delete')} placement="bottom">
                          <DeleteOutlined />
                        </Tooltip>
                      </Popconfirm>
                    }
                  >
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                      <Form.Item
                        style={{ flex: '50%' }}
                        labelCol={{ flex: '130px' }}
                        label={translation(translationCache, constant.tool)}
                        {...tool}
                        rules={[{ required: true }]}
                        name={[tool.name, 'ToolId']}
                        fieldKey={[tool.fieldKey, 'ToolId']}
                        key={index2}
                      >
                        <Select
                          style={{ width: '90%' }}
                          onChange={(value) =>
                            props.onToolChange(
                              value,
                              index2,
                              'Tools',
                              toolsList.filter((tool) => tool.Id === value)
                            )
                          }
                          placeholder={translation(translationCache, 'Select Tool')}
                        >
                          {toolsList.map((tool, index) => {
                            return (
                              <Option
                                key={index}
                                value={tool.Id}
                                disabled={
                                  props &&
                                    props.formObject &&
                                    props.formObject.Tools &&
                                    props.formObject.Tools.filter(
                                      (item) => item && item.ToolId === tool.Id
                                    ).length > 0
                                    ? true
                                    : false
                                }
                              >
                                {' '}
                                {tool.Tool}{' '}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        // style={{ flex: '50%' }}
                        // labelCol={{ flex: '130px' }}
                        // label={translation(translationCache, constant.availableQuantity)}
                        // disabled={true}
                        // {...tool}
                        name={[tool.name, 'AvailableQuantity']}
                      // fieldKey={[tool.fieldKey, 'AvailableQuantity']}
                      // key={index2}
                      >
                        {/* <InputComponent
                          disabled={true}
                          placeholder={translation(translationCache,"Total Quantity"
                          style={{ width: '90%' }}
                        /> */}
                      </Form.Item>
                      <Form.Item
                        style={{ flex: '50%' }}
                        labelCol={{ flex: '130px' }}
                        label={translation(translationCache, constant.description)}
                        // disabled={true}
                        // {...material}
                        name={[tool.name, 'Description']}
                        fieldKey={[tool.fieldKey, 'Description']}
                        key={index2}
                      >
                        <InputComponent
                          disabled={true}
                          placeholder={translation(translationCache, 'Auto Populate from Tool')}
                          style={{ width: '90%' }}
                        />
                      </Form.Item>
                      <Form.Item
                        style={{ flex: '50%' }}
                        labelCol={{ flex: '130px' }}
                        label={translation(translationCache, constant.Quantity)}
                        // validateTrigger="onChange"
                        {...tool}
                        name={[tool.name, 'Quantity']}
                        fieldKey={[tool.fieldKey, 'Quantity']}
                        key={index2}
                        rules={[
                          // {
                          // //  fieldKey[key][index2]['AvailableQuantity'] ==='Not Available' ?
                          // //     {
                          //       pattern: new RegExp(/^[0]*$/),
                          //       message: 'field accept only zero'
                          //     // }
                          //     //  : ''

                          // },
                          {
                            validator: (_, value) =>
                              checkAvailability(_, value, 'Tools', index2, props.formObject, {
                                validateDecimal: true
                              })
                          }
                        ]}
                      >
                        <InputNumberComponent
                          // min={0}
                          // max={1000}
                          // disabled={this.state.view}
                          placeholder={translation(translationCache, 'Quantity')}
                          style={{ width: '90%' }}
                          addonAfter={
                            <Tooltip
                              style={{ marginRight: '20px', flex: '50%' }}
                              labelCol={{ flex: '130px' }}
                              title={
                                'AvailableQuantity  -  ' +
                                (props &&
                                  props.formObject &&
                                  props.formObject.Tools &&
                                  props.formObject.Tools[index2] &&
                                  props.formObject.Tools[index2].AvailableQuantity
                                  ? props.formObject.Tools[index2].AvailableQuantity
                                  : 'Not Available')
                              }
                            >
                              <QuestionCircleOutlined />
                            </Tooltip>
                          }
                        />
                      </Form.Item>
                      <Form.Item style={{ flex: '50%' }} labelCol={{ flex: '130px' }} {...tool}>
                        {/* <Tooltip
                          style={{ marginRight: '20px', flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          title={
                            'AvailableQuantity  -  ' +
                            (props &&
                            props.formObject &&
                            props.formObject.Tools &&
                            props.formObject.Tools[index2] &&
                            props.formObject.Tools[index2].AvailableQuantity
                              ? props.formObject.Tools[index2].AvailableQuantity
                              :'Not Available')
                          }
                        >
                          <QuestionCircleOutlined style={{  color: 'white' }} />
                        </Tooltip> */}
                      </Form.Item>
                      <Form.Item style={{ flex: '50%' }}>
                        <InputComponent style={{ display: 'none' }} />
                      </Form.Item>
                      {/* <Col span={1}>
                    <Popconfirm
                      title="Are you sure that you want to  delete the Tool ?"
                      icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                      onConfirm={() => remove(tool.name)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <MinusCircleOutlined className="deleteIcon" />
                    </Popconfirm>
                  </Col> */}
                    </div>
                  </Panel>
                ))}
              </Collapse>
            ) : null}
          </Fragment>
        );
      }}
    </Form.List>
  );
};
const MaterialFormFunction = (props) => {
  const [materialsList, setTool] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache);
  useEffect(() => {
    (async () => {
      try {
        let response = await getMaterialsList();
        setTool(response.data);
      } catch (e) {
        return {};
      }
    })();
  }, []);

  return (
    <div>
      <Form.List name={'Materials'}>
        {(Materials, { add, remove }) => {
          return (
            <Fragment>
              <Form.Item>
                <div style={{ display: 'flex', justifyContent: 'right' }}>
                  <Button
                    type="dashed"
                    style={{ background: '#29415a', color: '#fff' }}
                    onClick={() => {
                      add();
                    }}
                  >
                    {translation(translationCache, constant.addMaterial)}{' '}
                  </Button>
                </div>
              </Form.Item>
              {Materials && Array.isArray(Materials) && Materials.length > 0 ? (
                <Collapse accordion defaultActiveKey={[]}>
                  {Materials.map((material, index2) => (
                    <Panel
                      key={index2}
                      header={`${translation(translationCache, constant.material)}${index2 + 1}`}
                      extra={
                        <Popconfirm
                          title={translation(translationCache, constant.deleteMaterial1)}
                          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                          // onConfirm={() => remove(material.name)}
                          onConfirm={() => remove(material.name)}
                          okText={translation(translationCache, constant.yes)}
                          cancelText={translation(translationCache, constant.no)}
                        >
                          <Tooltip
                            title={translation(translationCache, 'Delete')}
                            placement="bottom"
                          >
                            <DeleteOutlined />
                          </Tooltip>
                        </Popconfirm>
                      }
                    >
                      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          label={translation(translationCache, constant.material)}
                          rules={[{ required: true }]}
                          {...material}
                          name={[material.name, 'MaterialId']}
                          fieldKey={[material.fieldKey, 'MaterialId']}
                          key={index2}
                        >
                          <Select
                            style={{ width: '90%' }}
                            onChange={(value) =>
                              props.onMaterialChange(
                                value,
                                index2,
                                'Materials',
                                materialsList.filter((Item) => Item.Id === value)
                              )
                            }
                            placeholder={translation(translationCache, 'Select Material')}
                          >
                            {materialsList.map((material, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={material.Id}
                                  disabled={
                                    props &&
                                      props.formObject &&
                                      props.formObject['Materials'] &&
                                      props.formObject['Materials'].filter(
                                        (item) => item && item.MaterialId === material.Id
                                      ).length > 0
                                      ? true
                                      : false
                                  }
                                >
                                  {' '}
                                  {material.Material}{' '}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          // style={{ flex: '50%' }}
                          // labelCol={{ flex: '130px' }}
                          // label={translation(translationCache, constant.availableQuantity)}
                          // disabled={true}
                          // {...material}
                          name={[material.name, 'AvailableQuantity']}
                        // fieldKey={[material.fieldKey, 'AvailableQuantity']}
                        // key={index2}
                        >
                          {/* <InputComponent
                            disabled={true}
                            placeholder={translation(translationCache,"Autopopulate Basis To The Material"
                            style={{ width: '90%' }}
                          /> */}
                        </Form.Item>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          label={translation(translationCache, constant.description)}
                          // disabled={true}
                          // {...material}
                          name={[material.name, 'Description']}
                          fieldKey={[material.fieldKey, 'Description']}
                          key={index2}
                        >
                          <InputComponent
                            disabled={true}
                            placeholder={translation(
                              translationCache,
                              'Auto Populate from Material'
                            )}
                            style={{ width: '90%' }}
                          />
                        </Form.Item>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          label={translation(translationCache, constant.Quantity)}
                          validateTrigger="onChange"
                          {...material}
                          name={[material.name, 'Quantity']}
                          fieldKey={[material.fieldKey, 'Quantity']}
                          key={index2}
                          rules={[
                            // {
                            //   // pattern: new RegExp(/^[0-9]*$/),
                            //   message: 'field accept only numbers'
                            // },
                            {
                              validator: (_, value) =>
                                checkAvailability(_, value, 'Materials', index2, props.formObject, {
                                  validateDecimal: true
                                })
                            }
                          ]}
                        >
                          <InputNumberComponent
                            placeholder={translation(translationCache, 'Quantity')}
                            // min={0}
                            style={{ width: '90%' }}
                            addonAfter={
                              <Tooltip
                                style={{ marginRight: '20px', flex: '50%' }}
                                labelCol={{ flex: '130px' }}
                                title={
                                  'AvailableQuantity  -  ' +
                                  (props &&
                                    props.formObject &&
                                    props.formObject.Materials &&
                                    props.formObject.Materials[index2] &&
                                    props.formObject.Materials[index2].AvailableQuantity
                                    ? props.formObject.Materials[index2].AvailableQuantity
                                    : 'Not Available')
                                }
                              >
                                <QuestionCircleOutlined />
                              </Tooltip>
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          style={{ flex: '50%' }}
                          labelCol={{ flex: '130px' }}
                          {...material}
                        >
                          {/* <Tooltip
                            style={{ marginRight: '20px', flex: '50%' }}
                            labelCol={{ flex: '130px' }}
                            title={
                              'AvailableQuantity  -  ' +
                              (props &&
                                props.formObject &&
                                props.formObject.Materials &&
                                props.formObject.Materials[index2] &&
                                props.formObject.Materials[index2].AvailableQuantity
                                ? props.formObject.Materials[index2].AvailableQuantity
                                : 'Not Available')
                            }
                          >
                            <QuestionCircleOutlined style={{  color: 'white' }} />
                          </Tooltip> */}
                        </Form.Item>
                        <Form.Item style={{ flex: '50%' }}>
                          <InputComponent style={{ display: 'none' }} />
                        </Form.Item>
                      </div>
                    </Panel>
                  ))}
                </Collapse>
              ) : null}
            </Fragment>
          );
        }}
      </Form.List>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};
const Toolsform = connect(mapStateToProps)(ToolsformFunction);
const MaterialForm = connect(mapStateToProps)(MaterialFormFunction);

export { Toolsform, MaterialForm };
